import { LocalStorageService } from "@dodo/local-storage";

const localStorageService = new LocalStorageService({
	storageType: "session"
});

export function localStorageStateRestore<T>(
	stateKey: string,
	defaultState: T,
	showLog = false
): T {
	const localStorageState = <T>localStorageService.get(stateKey);

	if (localStorageState) {
		if (showLog) {
			console.log(
				`Loading state for "${stateKey}" from local storage : `,
				localStorageState
			);
		}
		return localStorageState;
	} else {
		if (showLog) {
			console.log(
				`Loading default state for "${stateKey}" from local storage`,
				defaultState
			);
		}
		return defaultState;
	}
}

export function localStorageStateStore(stateKey: string, state: any) {
	if (state) {
		localStorageService.set(stateKey, state);
	} else {
		localStorageService.delete(stateKey);
	}
}

export function localStorageStateClear(stateKey: string) {
	localStorageService.delete(stateKey);
}

export function localStorageStateClearAll() {
	localStorageService.clear();
}

export const LocalStorageKeys = {
	cqsa: "cqsa",
	productQualification: "product-qualification",
	productAvailability: "product-availability",
	mobileQualification: "mobile-qualification",
	energyQualification: "energy-qualification",
	broadbandQualification: "broadband-qualification",
	energyMultipleAddresses: "energy-multiple-addresses",
	fullSq: "internet-full-sq",
	salesId: "sales-id-info",
	userSelection: "user-selection",
	internetPlans: "internet-plans",
	internetPlanSelection: "internet-plan-selection",
	inPlaceCheck: "in-place-check",
	nextSteps: "next-steps",
	mobilePlans: "mobile-plans",
	mobilePlanSelection: "mobile-plan-selection",
	cartProducts: "cart-products",
	cartAboutYou: "cart-about-you",
	cartServiceTransfer: "cart-service-transfer",
	cartMobileServiceTransfer: "cart-mobile-service-transfer",
	cartEnergyServiceSetup: "cart-energy-service-setup",
	cartProofOfIds: "cart-proof-of-ids",
	cartPersist: "cart-payment-persist",
	cartSave: "cart-save",
	cartBlacklistCheck: "cart-payment-blacklist-check",
	cartTerms: "cart-payment-terms",
	cartStatus: "cart-payment-status",
	cartCheckToken: "cart-check-token-response",
	cartPaymentIframe: "cart-payment-iframe",
	cartDirectDebitInfo: "cart-direct-debit-info",
	nbnConsents: "nbn-consents",
	cartWizard: "cart-wizard",
	resellerId: "reseller-id",
	sim: "sim",
	promoDiscountCode: "promo-discount-code",
	validatedPromo: "validated-promo",
	dataLimit: "data_limit",
	speed: "speed",
	contract: "contract",
	productType: "prod_type",
	gnafId: "gnaf_id",
	dealer: "dealer",
	kiosk: "kiosk",
	energyCqsa: "energy-cqsa",
	energyPlans: "energy-plans",
	energyPlanSelection: "energy-plan-selection",
	lifeSupportEqups: "life-support-equips",
	concessionTypes: "concession-types",
	concessionWarCodes: "concession-war-codes",
	quote: "quote",
	plan: "plan",
	thankYouUrl: "thank-you-url",
	existingCustomer: "existing-customer",
	iframeUrl: "iframeUrl",
	target: "target",
	salesforceLeadId: "sf-lead-id",
	isSalesFlowTransition: "sales-flow-transition",
	energyAvailability: "energy-availability",
	addressFromEnergy: "address-energy",
	addressFromNBN: "address-nbn",
	gasSale: "gas-sale",
	electricitySale: "electricity-sale",
	nbnSale: "nbn-sale",
	thankyouPageHeading: "thankyou-page-heading",
	promoStackingBehavior: "promoStackingBehavior",
};
